import { __assign } from "tslib";
import React from 'react';
var IframePlayer = function (_a) {
    var url = _a.url, dimensions = _a.dimensions;
    return (React.createElement("iframe", { "data-hook": "video-iframe-placeholder", className: "gallery-item-content video-iframe-placeholder", title: "pro-gallery-video", style: __assign({}, dimensions), allow: 'fullscreen', src: url, allowFullScreen: true, loading: "lazy" }));
};
export default IframePlayer;
//# sourceMappingURL=IframeVideoPlayer.js.map